import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBrokenChainLink2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBrokenChainLink2"><Path d="M15.5 17.5H22.5V6.5H15.5M8.5 17.5H1.5V6.5H8.5" stroke="currentColor" strokeLinecap="square"/><Path d="M10.5 4.5L9.49997 1.5M13.5 4.5L14.5 1.5M10.5 19.5L9.49988 22.5M13.5 19.5L14.4999 22.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBrokenChainLink2;
